export default async () => {
  useTrackStore().init()
  await useAuthStore().reAuthenticate()
}
